import { Divider } from 'antd';

const Gammaplex = () => {
  return (
    <>
      <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
        <Divider />
        <p className="m-2">
          <b>Indication and Important Safety Information for Gammaplex 10%</b>
        </p>

        <p className="m-2">
          Gammaplex 10% (immune globulin intravenous [human], 10% liquid) is indicated for
          replacement therapy in primary humoral immunodeficiency (PI) in adults and pediatric
          patients two years of age and older. This includes, but is not limited to, the humoral
          immune defect in common variable immunodeficiency, X-linked agammaglobulinemia, congenital
          agammaglobulinemia, Wiskott-Aldrich syndrome, and severe combined immunodeficiencies.
        </p>

        <p className="m-2">
          Gammaplex 10% is also indicated for the treatment of chronic immune thrombocytopenic
          purpura (ITP) in adults.
        </p>

        <div>
          <div className="solid text-md m-2 border border-[#000000] p-2 text-black">
            <p className="m-2">
              <b>WARNING: THROMBOSIS, RENAL DYSFUNCTION and ACUTE RENAL FAILURE</b>
            </p>
            <li className="m-3">
              <b>
                Thrombosis may occur with immune globulin products, including Gammaplex 10%. Risk
                factors may include: advanced age, prolonged immobilization, hypercoagulable
                conditions, history of venous or arterial thrombosis, use of estrogens, indwelling
                central vascular catheters, hyperviscosity and cardiovascular risk factors.
                Thrombosis may occur in the absence of known risk factors.
              </b>
            </li>
            <li className="m-3">
              <b>
                Renal dysfunction, acute renal failure, osmotic nephrosis, and death may occur in
                predisposed patients who receive immune globulin intravenous (IGIV) products,
                including Gammaplex 10%.
              </b>
            </li>
            <li className="m-3">
              <b>
                Patients predisposed to renal dysfunction include those with any degree of
                pre-existing renal insufficiency, diabetes mellitus, age greater than 65, volume
                depletion, sepsis, paraproteinemia, or patients receiving known nephrotoxic drugs.
                Renal dysfunction and acute renal failure occur more commonly in patients receiving
                IGIV products containing sucrose. Gammaplex 10% does not contain sucrose.
              </b>
            </li>
            <li className="m-3">
              <b>
                For patients at risk of thrombosis, renal dysfunction or acute renal failure,
                administer Gammaplex 10% at the minimum dose and infusion rate practicable. Ensure
                adequate hydration in patients before administration. Monitor for signs and symptoms
                of thrombosis and assess blood viscosity in patients at risk for hyperviscosity.
              </b>
            </li>
          </div>
          <p className="m-2 mt-6">
            Gammaplex 10% is contraindicated in patients who have had an anaphylactic or severe
            systemic reaction to the administration of human immune globulin and IgA-deficient
            patients with antibodies to IgA and a history of hypersensitivity.
          </p>
          <p className="m-2 mt-3">
            In patients at risk of developing acute renal failure, monitor renal function, including
            blood urea nitrogen (BUN), serum creatinine and urine output. Hyperproteinemia,
            increased serum viscosity, and hyponatremia may occur in patients receiving IGIV
            therapy.
          </p>
          <p className="m-2 mt-3">
            Aseptic meningitis syndrome (AMS) may occur with IGIV treatment. AMS usually begins
            within several hours to 2 days following IGIV treatment. Discontinuation of IGIV
            treatment has resulted in remission of AMS within several days without sequelae. AMS may
            occur more frequently in association with high doses (2 g/kg) and/or rapid infusion of
            IGIV.
          </p>
          <p className="m-2 mt-3">
            Hemolysis and hemolytic anemia can develop subsequent to IGIV treatments. Patient risk
            factors that may be associated with development of hemolysis include high dose (&gt;2
            g/kg), non-O blood group, and underlying inflammatory state. Noncardiogenic pulmonary
            edema may occur in patients following IGIV treatment (i.e. transfusion-related acute
            lung injury [TRALI]). Monitor patients for pulmonary adverse reactions. If TRALI is
            suspected, test product and patient’s serum for anti-neutrophil antibodies.
          </p>
          <p className="m-2 mt-3">
            Gammaplex 10% is made from human plasma and may contain infectious agents, e.g. viruses
            and, theoretically, the Creutzfeldt-Jakob disease agent. No cases of transmission of
            viral diseases or CJD have been associated with the use of Gammaplex 10%.
          </p>
          <p className="m-2 mt-3">
            The most common adverse reactions in adult subjects receiving Gammaplex 10% in the PI
            clinical trial were headache, migraine, and pyrexia. The most common adverse reaction in
            pediatric subjects receiving Gammaplex 10% in the PI clinical trial was headache. There
            were no serious product-related adverse reactions observed in adult or pediatric
            clinical trial subjects with PI. The safety of Gammaplex 10% has not been established in
            patients with ITP. However, the safety profile for Gammaplex 5% has been studied in
            subjects with ITP, and it is anticipated that the safety profile for both formulations
            are comparable for ITP patients. The most common adverse reactions in adult subjects
            receiving Gammaplex 5% in the chronic ITP clinical trial were headache, vomiting,
            nausea, pyrexia, arthralgia, and dehydration. Serious adverse reactions observed in
            clinical trial subjects with ITP were headache, vomiting and dehydration.
          </p>

          <div>
            <p className="m-2">
              <b>
                Please see
                <a
                  target="_blank"
                  href="http://www.gammaplex.com/prescribing-information"
                  className="text-blue-500"
                >
                  &nbsp; Full Prescribing Information for complete prescribing details.
                </a>
              </b>
            </p>
            <p className="m-2">
              <b>
                You are encouraged to report negative side effects of prescription drugs to the FDA.
                Visit
                <a target="_blank" href="http://www.fda.gov/medwatch" className="text-blue-500">
                  &nbsp;www.fda.gov/medwatch&nbsp;
                </a>
                or call 1-800-FDA-1088.
              </b>
            </p>
            <p className="m-2">
              <b>You may also call Kedrion at 1-866-398-0825 or email US_Medicalinfo@kedrion.com</b>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Gammaplex;
